const sectionConfig = [
  {
    id: "training",
    destination: "ai",
    routes: [
      "features",
      "conclusions",
      "tags",
      "spectra",
      "assessments_pending",
      "assessments_finished",
      "diagnoses",
    ],
  },
  {
    id: "testing",
    destination: "portal",
    scope: "organisation",
    routes: ["test", "assessments" /*, "reports"*/, "participants", "staff"],
  },
  {
    id: "administering",
    destination: "ai",
    routes: ["organisations", "users"],
  },
];

export default sectionConfig;
